export default {
  delivery: {
    id: 'reassurance_service_delivery',
    defaultMessage: 'Express Delivery',
  },
  paymentServiceAdviceNew: {
    id: 'reassurance_service_advice_new',
    defaultMessage: 'Ratings from our Backers: {rate}/{maxRate}',
  },
  paymentPageVerified: {
    id: 'product_page_verified',
    defaultMessage: 'Verified refurbished',
  },
  satisfaction: {
    id: 'reassurance_cooling_off_days',
    defaultMessage: '{days}-day money back guarantee',
  },
  warranty: {
    id: 'reassurance_service_warranty',
    defaultMessage: '{warrantyDuration}-year minimum warranty',
  },
}
